/* =============================================================
   TRESTLETHORN — Parallax Hero JS
   File: assets/tt-hero.js
   Add to layout/theme.liquid before </body>:
     <script src="{{ 'tt-hero.js' | asset_url }}" defer></script>
   ============================================================= */

(function () {
  'use strict';

  /* ── Parallax ──
     Moves the background image at half scroll speed.
     Uses requestAnimationFrame + IntersectionObserver so it
     only runs while the hero is visible — zero cost offscreen.
  ── */
  function initParallax() {
    const wraps = document.querySelectorAll('.tt-hero__parallax-wrap');
    if (!wraps.length) return;

    // Skip if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Skip on touch devices (parallax can feel laggy on mobile)
    if ('ontouchstart' in window) return;

    const state = { ticking: false, active: new Set() };

    wraps.forEach(wrap => {
      // Watch visibility
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          state.active.add(wrap);
        } else {
          state.active.delete(wrap);
          wrap.style.transform = '';
        }
      }, { threshold: 0 });

      observer.observe(wrap.closest('.tt-hero'));
    });

    function updateParallax() {
      state.active.forEach(wrap => {
        const hero   = wrap.closest('.tt-hero');
        const rect   = hero.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const vMid   = window.innerHeight / 2;
        // shift = distance from center × 0.25 (quarter speed)
        const shift  = (center - vMid) * 0.25;
        wrap.style.transform = `translateY(${shift}px)`;
      });
      state.ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!state.ticking && state.active.size > 0) {
        requestAnimationFrame(updateParallax);
        state.ticking = true;
      }
    }, { passive: true });

    // Initial position
    requestAnimationFrame(updateParallax);
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }

  document.addEventListener('shopify:section:load', initParallax);

})();
